import React, { ReactNode } from 'react'
import NavBar from '../components/layouts/navbar/NavBar'
import NavBarSSO from '../components/layouts/navbar/NavBarSSO'

interface AuthLayoutProps {
    children: ReactNode
}

const AuthLayout: React.FC<AuthLayoutProps> = (props) => {
    const authMethod = process.env.NEXT_PUBLIC_AUTH_METHOD || 'CREDENTIALS'

    if (authMethod === 'OIDC' || authMethod === 'OIDC-AND-CREDENTIALS')
        return (
            <div className="min-h-full">
                <NavBarSSO />
                {props.children}
            </div>
        )

    return (
        <div className="min-h-full">
            <NavBar />
            {props.children}
        </div>
    )
}

export default AuthLayout
